/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { SlsInvIndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const slsInvIndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  selectedDocuments: []
});

export const slsInvIndexFetchSlsInvIndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const slsInvIndexFetchSlsInvIndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const slsInvIndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const slsInvIndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const slsInvIndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const slsInvIndexWorkspaceLoading = (state, { boolean }) => ({
  ...state,
  workspaceIsLoading: boolean
});

export const slsInvIndexResetSlsInvSync01Success = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [SlsInvIndexTypes.SLS_INV_INDEX_RESET_TIMESTAMP]: slsInvIndexResetTimestamp,
  [SlsInvIndexTypes.SLS_INV_INDEX_FETCH_SLS_INV_INDEX_LOADING]: slsInvIndexFetchSlsInvIndexLoading,
  [SlsInvIndexTypes.SLS_INV_INDEX_FETCH_SLS_INV_INDEX_SUCCESS]: slsInvIndexFetchSlsInvIndexSuccess,
  [SlsInvIndexTypes.SLS_INV_INDEX_ADD_SELECTED_DOCUMENTS]: slsInvIndexAddSelectedDocuments,
  [SlsInvIndexTypes.SLS_INV_INDEX_REMOVE_SELECTED_DOCUMENTS]: slsInvIndexRemoveSelectedDocuments,
  [SlsInvIndexTypes.SLS_INV_INDEX_SET_WORKSPACE_VISIBLE]: slsInvIndexSetWorkspaceVisible,
  [SlsInvIndexTypes.SLS_INV_INDEX_WORKSPACE_LOADING]: slsInvIndexWorkspaceLoading,
  [SlsInvIndexTypes.SLS_INV_INDEX_RESET_SLS_INV_SYNC01_SUCCESS]: slsInvIndexResetSlsInvSync01Success
});
